import banmedicaTheme from "./../../config/banmedicaTheme";

const styles = {
  frameContenidoGeneral: {
    paddingTop: 5,
    paddingRight: 10,
    paddingBottom: 0,
    paddingLeft: 10,
  },
  formatColumnHeader: {
    whiteSpace: "normal",
    wordWrap: "break-word",
  },
  customWidth: {
    width: 250,
    fontSize: "13px",
  },
  customWidth100: {
    width: "100%",
    fontSize: "13px",
  },
  customWidthItem: {
    width: 240,
    fontSize: "13px",
  },
  // Icono Menu
  svgMenuStyleResultado: {
    marginTop: -9,
    marginLeft: -9,
    height: 25,
    width: 25,
    fill: "#fff",
  },
  iconMenuStyle: {
    backgroundColor: banmedicaTheme.palette.accent1Color,
    borderRadius: 7,
    height: 30,
    width: 30,
  },
  // Estilos Texto
  h1: {
    fontSize: 18,
    fontWeight: 500,
    color: "#4D5D73",
    fontFamily: "Tahoma",
  },
  h2: {
    fontSize: 12,
    fontWeight: 400,
    color: "#727272",
  },
  h3: {
    fontSize: 13,
    fontWeight: 500,
    color: "#727272",

  },
  h4: {
    fontSize: 12,
    fontWeight: 500,
    color: "#3E3E3E",
    textTransform: "capitalize",
    marginTop: -9,
    paddingLeft: 5,
  },
  h5: {
    fontSize: 12,
    fontWeight: 500,
    color: "#3E3E3E",
    textTransform: "capitalize",
    paddingLeft: 5,
  },
  // Select Field
  errorStyle: {
    marginTop: 10,
    whiteSpace: "normal",
  },
  codFonasaLoading: {
    position: "relative",
    bottom: 2,
    fontSize: "12px",
    lineHeight: "12px",
    color: "#bdbdbd",
    marginTop: 10,
  },
  codFonasaValido: {
    position: "relative",
    bottom: 2,
    fontSize: "12px",
    lineHeight: "12px",
    color: "#43942f",
    marginTop: 10,
  },
  colSelectFieldActualizar: {
    paddingLeft: 0,
    paddingRight: 20,
  },
  floatingClaseSelect: {
    paddingTop: 20,
    fontSize: 11,
    fontWeight: 500,
    color: "#626262",
  },
  floatingClaseSelect2: {
    fontSize: 11,
    fontWeight: 500,
    color: "#626262",
  },
  colBotonesActualizar: {
    padding: 0,
    textAlign: "right",
    alignSelft: "center",
  },
  underlineSelectField: {
    borderBottom: "0px solid #fff",
  },
  iconSelectField: {
    marginTop: -9,
  },
  selectFiledStyle: {
    height: 30,
    paddingTop: -5,
    border: "2px solid #C3C3C3",
    borderRadius: 5,
    width: 250,
  },
  selectFiledStyle2: {
    height: 30,
    paddingTop: -5,
    border: "2px solid #C3C3C3",
    borderRadius: 5,
    width: 150,
  },
  selectFiledStyleRecargosConvenios: {
    height: 30,
    paddingTop: -5,
    border: "2px solid #C3C3C3",
    borderRadius: 5,
    width: 350,
  },
  menuItemStyleSelectField: {
    fontSize: 12,
    color: "#3E3E3E",
    fontWeight: 400,
  },
  selectedMenuItemSelectField: {
    color: banmedicaTheme.palette.accent1Color,
    fontSize: 12,
    fontWeight: 600,
  },
  selectFieldNuevaPrestacion: {
    height: 30,
    paddingTop: -5,
    border: "2px solid #C3C3C3",
    borderRadius: 5,
    width: 200,
  },
  selectFieldNuevaPrestacionTablaInferior: {
    height: 30,
    paddingTop: -5,
    border: "2px solid #C3C3C3",
    borderRadius: 5,
    width: 135,
  },
  textFieldSolicitudObservacion: {
    // height: 120,
    // paddingTop: -5,
    border: "1px solid #000000",
    borderRadius: 3,
    width: "90%",
  },


  // Grilla Búsqueda
  tituloTablaBusqueda1: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "120px",
    textAlign: "center",
  },
  tituloTablaBusqueda2: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 10,
    margin: 0,
    height: 30,
    width: "410px",
    textAlign: "center",
  },
  tituloTablaBusqueda3: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "120px",
    textAlign: "center",
  },
  tituloTablaBusqueda4: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "120px",
    textAlign: "center",
  },
  tituloTablaBusqueda5: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "90px",
    textAlign: "center",
  },
  tituloTablaBusqueda6: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "90px",
    textAlign: "center",
  },
  tituloTablaBusqueda7: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "90px",
    textAlign: "center",
  },
  tituloTablaBusqueda8: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "125px",
    textAlign: "center",
  },
  tituloTablaBusqueda9: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 20,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "175px",
  },
  tituloTablaBusqueda10: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "70px",
    textAlign: "center",
  },
  tituloTablaBusqueda11: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "90px",
  },
  datoTablaBusqueda1: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 20,
    paddingRight: 0,
    margin: 0,
    width: "120px",
  },
  datoTablaBusqueda2: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 10,
    margin: 0,
    width: "410px",
  },
  datoTablaBusqueda3: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 30,
    paddingRight: 0,
    margin: 0,
    width: "120px",
  },
  datoTablaBusqueda4: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 50,
    paddingRight: 0,
    margin: 0,
    width: "120px",
  },
  datoTablaBusqueda5: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 15,
    paddingRight: 0,
    margin: 0,
    width: "90px",
  },
  datoTablaBusqueda6: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "90px",
    textAlign: "center",
  },
  datoTablaBusqueda7: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "90px",
    textAlign: "center",
  },
  datoTablaBusqueda8: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 30,
    paddingRight: 0,
    margin: 0,
    width: "125px",
  },
  datoTablaBusqueda9: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    width: "175px",
  },
  datoTablaBusqueda10: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 18,
    paddingRight: 0,
    margin: 0,
    width: "70px",
  },
  datoTablaBusqueda11: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    width: "90px",
  },

  //Tabla busqueda paquetes
  tituloTablaBusquedaP1: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "120px",
    textAlign: "center",
  },
  tituloTablaBusquedaP2: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 10,
    margin: 0,
    height: 30,
    width: "300px",
    textAlign: "center",
  },
  tituloTablaBusquedaP3: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "120px",
    textAlign: "center",
  },
  tituloTablaBusquedaP4: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "120px",
    textAlign: "center",
  },
  tituloTablaBusquedaP5: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "120px",
    textAlign: "center",
  },
  tituloTablaBusquedaP6: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "150px",
    textAlign: "center",
  },
  tituloTablaBusquedaP7: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "150px",
    textAlign: "center",
  },
  tituloTablaBusquedaP8: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "150px",
    textAlign: "center",
  },
  tituloTablaBusquedaP9: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 20,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "150px",
    textAlign: "center",
  },
  tituloTablaBusquedaP10: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "150px",
    textAlign: "center",
  },
  tituloTablaBusquedaP11: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "150px",
    textAlign: "center",
  },
  tituloTablaBusquedaP12: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "150px",
    textAlign: "center",
  },
  tituloTablaBusquedaP13: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "150px",
    textAlign: "center",
  },
  tituloTablaBusquedaP14: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "150px",
    textAlign: "center",
  },
  datoTablaBusquedaP1: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "120px",
    textAlign: "center",
  },
  datoTablaBusquedaP2: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "300px",
  },
  datoTablaBusquedaPP2: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "300px",
    textAlign: "center",
  },
  datoTablaBusquedaP3: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "120px",
    textAlign: "center",
  },
  datoTablaBusquedaP4: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "120px",
    textAlign: "center",
  },
  datoTablaBusquedaP5: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "120px",
    textAlign: "center",
  },
  datoTablaBusquedaP6: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "150px",
    textAlign: "center",
  },
  datoTablaBusquedaP7: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "150px",
    textAlign: "center",
  },
  datoTablaBusquedaP8: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "150px",
    textAlign: "center",
  },
  datoTablaBusquedaP9: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "150px",
    textAlign: "center",
  },
  datoTablaBusquedaP10: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "150px",
    textAlign: "center",
  },
  datoTablaBusquedaP11: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "150px",
    textAlign: "center",
  },
  datoTablaBusquedaP12: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "150px",
    textAlign: "center",
  },
  datoTablaBusquedaP13: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "150px",
    textAlign: "center",
  },
  datoTablaBusquedaP14: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "150px",
    textAlign: "center",
  },

  datoTablaCaracteristicasP1: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    width: "120px",
    textAlign: "left",
  },

  datoTablaDetalleP1: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    width: "120px",
    textAlign: "center",
  },



  // Tabla Nueva Prestación
  rowPrestacionTablaInferiorCheckSub: {
    paddingLeft: 10,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    width: 40,
  },
  rowPrestacionTablaInferiorCheckTA: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    width: 40,
  },
  rowPrestacionTablaInferiorCheckCC: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    width: 40,
  },
  rowPrestacionTablaInferior0: {
    paddingLeft: 10,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    width: 180,
    wordWrap: "break-word",
    whiteSpace: "normal",
  },
  rowPrestacionTablaInferior1: {
    paddingLeft: 10,
    paddingRight: 0,
    paddingTop: -10,
    paddingBottom: 0,
    marginTop: -10,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    width: 160,
  },
  rowPrestacionTablaInferior2: {
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    marginTop: 0,
    paddingTop: 25,
    paddingBottom: 0,
    width: 160,
  },

  // Grilla Solicitud
  tituloTabla1: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "80px",
  },
  tituloTabla2: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "93px",
    textAlign: "center",
  },
  tituloTabla3: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "110px",
    textAlign: "center",
  },
  tituloTabla4: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "110px",
    textAlign: "center",
  },
  tituloTabla5: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "110px",
    textAlign: "center",
  },
  tituloTabla6: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "65px",
  },
  tituloTabla7: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "55px",
    textAlign: "center",
  },
  tituloTabla8: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "65px",
    textAlign: "center",
  },
  tituloTabla9: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "120px",
    textAlign: "center",
  },
  tituloTabla10: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "170px",
    textAlign: "center",
  },
  tituloTabla11: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
  },
  tituloTabla12: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
  },
  tituloTabla13: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "85px",
  },
  comunStyleTable1: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "80px",
    textAlign: "center",
  },
  comunStyleTable2: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    width: "93px",
    textAlign: "center",
  },
  comunStyleTable3: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    width: "110px",
    textAlign: "center",
  },
  comunStyleTable4: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    width: "110px",
    textAlign: "center",
  },
  comunStyleTable5: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    width: "110px",
    textAlign: "center",
  },
  comunStyleTable6: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    width: "65px",
    textAlign: "center",
  },
  comunStyleTable7: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "55px",
    textAlign: "center",
  },
  comunStyleTable8: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "65px",
    textAlign: "center",
  },
  comunStyleTable9: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    width: "120px",
    textAlign: "center",
  },
  comunStyleTable9Error: {
    fontSize: 11,
    fontWeight: 400,
    color: "rgb(253, 63, 63)",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    width: "120px",
    textAlign: "center",
  },
  comunStyleTable10: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    width: "170px",
    textAlign: "center",
  },
  comunStyleTable11: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    width: "100px",
  },
  comunStyleTable12: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    width: "100px",
  },
  comunStyleTable13: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    width: "85px",
  },
  botonesResultadoBusqueda: {
    height: 30,
    width: 15,
    marginRight: 4,
  },
  svgStyleResultado: {
    marginTop: -9,
    marginLeft: -9,
    height: 25,
    width: 25,
    fill: "#BFBFBF",

  },
  iconStyleResultado: {
    marginTop: 4,
    height: 32,
    width: 32,
    marginRight: 10,
  },
  // Contadores
  contadoresStyle: {
    fontSize: 13,
    fontWeight: 600,
    Color: "##696969",

  },
  // Reajustar Arancel
  colBotonBusqueda: {
    paddingLeft: 45,
    marginTop: 12,
  },
  tituloTablaReajuste1: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 140,
  },
  tituloTablaReajuste2: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 130,
    textAlign: "center",
  },
  tituloTablaReajuste3: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 140,
    textAlign: "center",
  },
  tituloTablaReajuste4: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 150,
    textAlign: "center",
  },
  tituloTablaReajuste5: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 130,
    textAlign: "center",
  },
  tituloTablaReajuste6: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 250,
  },
  tituloTablaReajuste7: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 130,
    textAlign: "center",
  },
  tituloTablaReajuste8: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 75,
  },
  tituloTablaReajuste9: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 85,
    textAlign: "center",
  },
  tituloTablaReajuste10: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 30,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 80,
  },
  tituloTablaReajuste11: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 120,
    textAlign: "center",
  },
  tituloTablaReajuste12: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 100,
  },
  contTablaReajuste1: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 140,
  },
  contTablaReajuste2: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 30,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 130,
  },
  contTablaReajuste3: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 30,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 140,
  },
  contTablaReajuste4: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 25,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 150,
  },
  contTablaReajuste5: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 40,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 130,
  },
  contTablaReajuste6: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 250,
  },
  contTablaReajuste7: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 30,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 130,
  },
  contTablaReajuste8: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 75,
  },
  contTablaReajuste9: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 45,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 85,
  },
  contTablaReajuste10: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 40,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 80,
  },
  contTablaReajuste11: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 40,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 120,
  },
  contTablaReajuste12: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 100,
  },
  // Solicitudes Realizadas
  datepickerStyle: {
    height: 30,
    paddingTop: -5,
    border: "2px solid #C3C3C3",
    borderRadius: 5,
    width: 200,
    ":hover": {
      cursor: "pointer"
    }
  },
  tituloTablaSolicitudes1: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 80,
    textAlign: "left",
  },
  tituloTablaSolicitudes2: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 90,
    textAlign: "left",
  },
  tituloTablaSolicitudes3: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 100,
    textAlign: "left",
  },
  tituloTablaSolicitudes4: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 100,
    textAlign: "left",
  },
  tituloTablaSolicitudes5: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 100,
    textAlign: "left",
  },
  tituloTablaSolicitudes6: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 100,
    textAlign: "center",
  },
  tituloTablaSolicitudes7: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 100,
    textAlign: "center",
  },
  tituloTablaSolicitudes8: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 100,
    textAlign: "center",
  },
  contTablaSolicitudes1: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 20,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 80,
  },
  contTablaSolicitudes2: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 90,
  },
  contTablaSolicitudes3: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 100,
  },
  contTablaSolicitudes4: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 100,
  },
  contTablaSolicitudes5: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 100,
  },
  contTablaSolicitudes6: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 100,

  },
  contTablaSolicitudes7: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 100,
    textAlign: "center",
  },
  contTablaSolicitudes8: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: 100,
    textAlign: "center",
  },
  tituloTablaSolicitudesDetalle: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    textAlign: 'center',
    // textAlign: "left",
    whiteSpace: "normal",
    wordWrap: "break-word",
  },
  contTablaSolicitudesDetalle: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 20,
    paddingRight: 0,
    margin: 0,
    height: 30,
    textAlign: 'center',
    // whiteSpace: "normal",
    wordWrap: "break-word",
  },
  // Recargos Convenios
  colBotonBusquedaRecargos: {
    marginTop: 12,
  },
  tituloTablaRecargos1: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "30%",
  },
  tituloTablaRecargos2: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "30%",
  },
  tituloTablaRecargos3: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "30%",
  },
  contTablaRecargos2: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "80px",
  },
  contTablaRecargos3: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "80px",
  },
  tituloTablaConsultaRecargos0: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    textAlign: "center",
  },
  tituloTablaConsultaRecargos1: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "110px",
    textAlign: "center",
  },
  tituloTablaConsultaRecargos2: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "180px",
    textAlign: "center",
  },
  tituloTablaConsultaRecargos3: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "410px",
    textAlign: "center",
  },
  tituloTablaConsultaRecargos4: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "180px",
    textAlign: "center",
  },
  tituloTablaConsultaRecargos5: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "260px",
    textAlign: "center",
  },
  tituloTablaConsultaRecargos6: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
    textAlign: "center",
  },
  tituloTablaConsultaRecargos7: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
    textAlign: "center",
  },
  tituloTablaConsultaRecargos8: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "160px",
    textAlign: "center",
  },
  tituloTablaConsultaRecargos9: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
    textAlign: "center",
  },
  tituloTablaConsultaRecargos10: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
    textAlign: "center",
  },
  tituloTablaConsultaRecargos11: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
    textAlign: "center",
  },
  tituloTablaConsultaRecargos12: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
    textAlign: "center",
  },
  tituloTablaConsultaRecargos13: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
    textAlign: "center",
  },
  tituloTablaConsultaRecargos14: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
    textAlign: "center",
  },
  tituloTablaConsultaRecargos15: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
    textAlign: "center",
  },
  tituloTablaConsultaRecargos16: {
    fontSize: 12,
    fontWeight: 600,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
    textAlign: "center",
  },
  contTablaConsultaRecargos1: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 40,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "110px",
  },
  contTablaConsultaRecargos2: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "180px",
    textAlign: "center",
  },
  contTablaConsultaRecargos3: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "410px",
  },
  contTablaConsultaRecargos4: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 40,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "180px",
  },
  contTablaConsultaRecargos5: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "260px",
  },
  contTablaConsultaRecargos6: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 30,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
  },
  contTablaConsultaRecargos7: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 30,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
  },
  contTablaConsultaRecargos8: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 70,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "160px",
  },
  contTablaConsultaRecargos9: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 40,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
  },
  contTablaConsultaRecargos10: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 40,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
  },
  contTablaConsultaRecargos11: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
  },
  contTablaConsultaRecargos12: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
  },
  contTablaConsultaRecargos13: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
  },
  contTablaConsultaRecargos14: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
  },
  contTablaConsultaRecargos15: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
  },
  contTablaConsultaRecargos16: {
    fontSize: 11,
    fontWeight: 400,
    color: "#626262",
    paddingLeft: 10,
    paddingRight: 0,
    margin: 0,
    height: 30,
    width: "100px",
  },
  // Modificar Prestación
  tituloModificarPrestacion: {
    width: 150,
    marginTop: 5,
    marginBottom: 5,
  },
  datoModificarPrestacion: {
    width: 150,
    marginTop: 5,
    marginBottom: 5,
    fontWeight: 500,
  },
  // Enviar Solicitud
  tituloEnviarSolicitud: {
    width: 200,
    marginTop: 5,
    marginBottom: 5,
  },
  datoEnviarSolicitud: {
    width: 200,
    marginTop: 5,
    marginBottom: 5,
    fontWeight: 500,
  },
  // Editar linea de detalle de solicitud
  tituloEditarLinea: {
    width: 150,
    marginTop: 5,
    marginBottom: 5,
  },
  datoEditarLinea: {
    width: 150,
    marginTop: 5,
    marginBottom: 5,
    fontWeight: 500,
    padding: 0,
  },
  // Reajuste por grupo de prestacion
  tituloReajustarPrestacionIpc: {
  },
  datoReajustarPrestacionIpc: {
    fontWeight: 500,
  },
  // Reajustar Arancel
  datepickerStyleFecha: {
    height: 30,
    paddingTop: -5,
    border: "2px solid #C3C3C3",
    borderRadius: 5,
    width: 300,
  },
  errorBox: {
    padding: "10px",
    borderRadius: "8px",
    backgroundColor: "rgba(199, 0, 0, 0.5)",
    color: "black",
    width: "580px",
    maxHeight: "80px",
    textAlign: "center"
  }
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/styles/styles.jsx